
import React, { useState, useImperativeHandle, forwardRef } from 'react'
import styled from "styled-components"
// import { DescContent, Ctitle, DescIcon, IconClose } from './style'
import close from '../images/ico_tc_close@2x.png'
import { Modal } from 'antd-mobile'

const Explain = ({top}, ref) => {
	const [descVisible, setDescVisible] = useState(false)
  useImperativeHandle(ref, () => {
    return {
      setShow: (addrInfo) => {
        setDescVisible(true)
      }
    }
  })
	return (
		<React.Fragment>
			
			<Modal 
				visible={descVisible} 
   
        wrapClassName="lx-desc-modal-outer"
        className={'lx2-desc-modal'} 
				transparent onClose={() => setDescVisible(false)}>
          <div style={{width: '',fontSize: '0px'}}>
            <img style={{width: '100%'}} src={require('../images/发货通知@2x.png')} alt=''></img>
          </div>

          <IconClose onClick={() => setDescVisible(false)} />
			</Modal>
 
		</React.Fragment>
	)
}


export  const IconClose = styled.div`
  width: 40px;
  height:40px;
  position: fixed;
  z-index: 400;
  bottom: -11vw;
  left: 48%;
  background-image: url(${close});
  background-size: 25px 25px;
  background-repeat: no-repeat;
  background-position: center center;
`

export default React.memo(forwardRef(Explain));



// WEBPACK FOOTER //
// ./src/views/activity_139/components/modal.js